import { useState } from "react";
import { getStats } from "@/data/stats";

export const StatsBar = () => {
  const [stats] = useState(() => getStats());
  return (
    <section className="border-b border-stone bg-white" aria-label="Industrix Solution at a glance" data-testid="stats-bar">
      <dl className="wrap grid grid-cols-2 gap-px overflow-hidden lg:grid-cols-4">
        {stats.map((s) => (
          <div key={s.label} className="flex flex-col-reverse items-center bg-white py-10 text-center lg:py-14" data-testid={s.testId}>
            <dt className="mt-3 font-mono text-[11px] uppercase tracking-[0.18em] text-graphite sm:text-xs">{s.label}</dt>
            <dd className="font-display text-4xl font-extrabold leading-none text-charcoal sm:text-5xl lg:text-6xl" style={{ fontStretch: "115%" }}>
              {s.value}
              <span className="text-rust">{s.suffix}</span>
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
};
